export default __webpack_public_path__ + "static/media/snooze-grey.9eaf8142.svg";